import React, { useState } from "react";
import AdminHistory from "@/components/admin/AdminHistory";
import AdminStaysSearch from "@/components/admin/AdminStaysSearch";

/**
 * Onglet admin "Journal" qui regroupe :
 *  - Sous-onglet "Réservations" (actif par défaut) : recherche + export Excel
 *  - Sous-onglet "Modifications" : journal d'audit (composant AdminHistory inchangé)
 */
export default function AdminJournal() {
  const [tab, setTab] = useState("reservations"); // "reservations" | "modifications"

  const pillBase =
    "px-4 py-1.5 rounded-full text-sm font-medium transition-colors border";
  const active = "bg-violet-500 text-white border-violet-500";
  const inactive =
    "bg-white/[0.04] text-slate-200 border-white/10 hover:bg-white/[0.10]";

  return (
    <div data-testid="admin-journal" className="space-y-4">
      <div data-testid="admin-journal-subtabs" className="flex items-center gap-2">
        <button
          data-testid="admin-journal-tab-reservations"
          type="button"
          className={`${pillBase} ${tab === "reservations" ? active : inactive}`}
          onClick={() => setTab("reservations")}
        >
          Réservations
        </button>
        <button
          data-testid="admin-journal-tab-modifications"
          type="button"
          className={`${pillBase} ${tab === "modifications" ? active : inactive}`}
          onClick={() => setTab("modifications")}
        >
          Modifications
        </button>
      </div>

      {tab === "reservations" ? <AdminStaysSearch /> : <AdminHistory />}
    </div>
  );
}
